module.exports = __webpack_public_path__ + "static/Luisa-Galindo-ff5330950678864bdec42b6199e5ee3c.png";